define('pages/rent-list',["exports", "models/list-state-rent", "views/filter-header-rent", "views/filter-modal-rent", "views/list"], function (_exports, _listStateRent, _filterHeaderRent, _filterModalRent, _list) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _listStateRent = _interopRequireDefault(_listStateRent);
  _filterHeaderRent = _interopRequireDefault(_filterHeaderRent);
  _filterModalRent = _interopRequireDefault(_filterModalRent);
  _list = _interopRequireDefault(_list);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var _default = _exports.default = _list.default.extend({
    initialize() {
      _list.default.prototype.initialize.apply(this, arguments);
      this._initState(_listStateRent.default, _filterHeaderRent.default, _filterModalRent.default);
    }
  });
});//# sourceMappingURL=rent-list.js.map
;
